import PopUp from '@/common/components/PopUp';
import { Title, ButtonWrapper } from './ConfirmDialog.styles';
import ActionButton from '@/common/components/buttons/ActionButton';
import { Colors } from '@/common/colors/colors';

const ConfirmDialog = ({ text, onClose, onConfirm, buttonText = 'Delete' }) => {
	return (
		<PopUp setShow={onClose}>
			<Title>{text}</Title>
			<ButtonWrapper>
				<ActionButton
					defaultText={buttonText}
					onClick={onConfirm}
					color={Colors.red}
				/>
			</ButtonWrapper>
		</PopUp>
	);
};

export default ConfirmDialog;
